import React from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { generatePath } from 'react-router';
import { useNavigate } from 'react-router-dom';

import ApartmentIcon from '@mui/icons-material/Apartment';
import {
  Avatar,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Stack,
} from '@mui/material';

import { isSafetracesAdmin } from 'Config/roles';
import { ROUTE_BUILDING_PROJECTS_RESULTS, ROUTE_TESTS } from 'Config/routes';

import { setCurrentBuildingName } from 'Features/Results/resultsSlice';
import { setTestsSuccess, testsSelector } from 'Features/Tests/testsSlice';

export default function ResultsItem({ item }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { currentBuildingId } = useSelector(testsSelector);
  /**
   * Open results of building
   * @param buildingId
   */
  const navigateToBuildingResults = (event) => {
    if (
      !~['Floor Level Results', 'Project Level Results'].indexOf(
        event.target.innerHTML.trim(),
      )
    ) {
      return;
    }

    const isFloorplsnsPartClicked =
      event.target.innerHTML === 'Floor Level Results';

    dispatch(setCurrentBuildingName(item.buildingname));
    if (parseInt(item.buildingid) !== parseInt(currentBuildingId)) {
      dispatch(setTestsSuccess([]));
    }
    const _path = generatePath(
      isFloorplsnsPartClicked ? ROUTE_BUILDING_PROJECTS_RESULTS : ROUTE_TESTS,
      { buildingId: item.buildingid },
    );

    /** This is for opening it in new tab through command + click or ctrl + click */
    if (event.metaKey || event.ctrlKey) {
      window.open(_path);
      return;
    }
    navigate(_path);
  };

  return (
    <ListItemButton
      onClick={navigateToBuildingResults}
      sx={{ maxWidth: '800px', borderRadius: 5 }}
    >
      <ListItemAvatar>
        <Avatar>
          <ApartmentIcon />
        </Avatar>
      </ListItemAvatar>
      <Stack direction="column" spacing={0}>
        <ListItemText
          primary={item.buildingname}
          secondary={`${item?.sitename || ''} ${item?.siteaddress || ''}`}
          secondaryTypographyProps={{ paddingRight: 2 }}
        />
        <ListItemText
          secondary={`Project Level Results `}
          secondaryTypographyProps={{
            paddingRight: 2,
            color: 'primary.main',
            sx: {
              '&:hover': {
                textDecoration: 'underline',
              },
            },
          }}
        />
        {isSafetracesAdmin() && item.hasVerificationHeatmap ? (
          <ListItemText
            custom_attr_link_name={'buildingProjectsResults_' + item.buildingid}
            secondary={`Floor Level Results`}
            secondaryTypographyProps={{
              paddingRight: 2,
              color: 'primary.main',
              sx: {
                '&:hover': {
                  textDecoration: 'underline',
                },
              },
            }}
          />
        ) : null}
      </Stack>
    </ListItemButton>
  );
}
